
export const WHATSAPP_NUMBER = '2250749103662';
export const TRIAL_DAYS = 7;
export const GOLD_DAYS = 30;
export const GOLD_PRICE = 10;
export const CURRENCY = '$';

export const I18N = {
  fr: {
    welcome: 'Omen',
    tagline: 'Sagesse Ancestrale, Succès Moderne',
    enterPin: 'Entrez votre code secret',
    setupPin: 'Créez votre code secret (6 chiffres)',
    unlock: 'Déverrouiller',
    dailyLesson: 'Leçon du Jour',
    wealth: 'Richesse',
    success: 'Succès',
    discipline: 'Discipline',
    actionToTake: 'Action à poser',
    powerfulPrayer: 'Prière Puissante',
    upgradeGold: 'Passer au Plan GOLD',
    planSilver: 'Plan SILVER',
    planGold: 'Plan GOLD',
    freeTrial: 'Gratuit (7 jours)',
    goldPremium: 'Premium (30 jours)',
    trialInfo: 'Votre période d\'essai se termine dans',
    activeStatus: 'Actif',
    expiredStatus: 'Expiré',
    remainingDays: 'jours restants',
    days: 'jours',
    goldFeatures: 'Accès illimité aux 3 livres sacrés, analyses IA profondes et sauvegardes sécurisées.',
    getGoldCode: 'Obtenir mon code GOLD via WhatsApp',
    enterGoldCode: 'Entrez le code reçu',
    validate: 'Valider',
    settings: 'Paramètres',
    backup: 'Sauvegarder les données',
    restore: 'Restaurer les données',
    invalidPin: 'Code invalide',
    invalidGoldCode: 'Code de validation incorrect',
    source: 'Source',
    generateNew: 'Nouvelle Inspiration',
    favorites: 'Mes Favoris',
    noFavorites: 'Aucun favori pour le moment',
    back: 'Retour',
    subscription: 'Abonnement',
    choosePlan: 'Choisissez votre Plan',
    share: 'Partager',
    addNote: 'Ajouter une note personnelle',
    saveNote: 'Enregistrer la note',
    noteSaved: 'Note enregistrée !',
    shareText: 'Découvrez cette leçon de Omen :',
    alreadyGenerated: 'Vous avez déjà reçu votre leçon pour aujourd\'hui. Revenez demain pour une nouvelle dose de sagesse !'
  },
  en: {
    welcome: 'Omen',
    tagline: 'Ancestral Wisdom, Modern Success',
    enterPin: 'Enter your secret pin',
    setupPin: 'Create your secret pin (6 digits)',
    unlock: 'Unlock',
    dailyLesson: 'Daily Lesson',
    wealth: 'Wealth',
    success: 'Success',
    discipline: 'Discipline',
    actionToTake: 'Action to Take',
    powerfulPrayer: 'Powerful Prayer',
    upgradeGold: 'Upgrade to GOLD Plan',
    planSilver: 'SILVER Plan',
    planGold: 'GOLD Plan',
    freeTrial: 'Free (7 days)',
    goldPremium: 'Premium (30 days)',
    trialInfo: 'Your trial period ends in',
    activeStatus: 'Active',
    expiredStatus: 'Expired',
    remainingDays: 'days remaining',
    days: 'days',
    goldFeatures: 'Unlimited access to all 3 holy books, deep AI insights, and secure backups.',
    getGoldCode: 'Get my GOLD code via WhatsApp',
    enterGoldCode: 'Enter received code',
    validate: 'Validate',
    settings: 'Settings',
    backup: 'Backup Data',
    restore: 'Restore Data',
    invalidPin: 'Invalid PIN',
    invalidGoldCode: 'Incorrect validation code',
    source: 'Source',
    generateNew: 'New Inspiration',
    favorites: 'My Favorites',
    noFavorites: 'No favorites yet',
    back: 'Back',
    subscription: 'Subscription',
    choosePlan: 'Choose your Plan',
    share: 'Share',
    addNote: 'Add a personal note',
    saveNote: 'Save note',
    noteSaved: 'Note saved!',
    shareText: 'Check out this lesson from Omen:',
    alreadyGenerated: 'You have already received your lesson for today. Come back tomorrow for more wisdom!'
  }
};
